import { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Megaphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, StatusBadge, EmptyState } from "@/components/Common";
import { JobFormDialog, JobMeta } from "@/components/JobForm";
import { useAuth } from "@/context/AuthContext";
import { useFetch, fmtDate, isMember } from "@/lib/api";

export const JobList = ({ jobs, base, admin }) => (
  <div className="space-y-3">
    {jobs.map((j) => (
      <Link key={j.id} to={`${base}/${j.id}`} data-testid={`job-row-${j.id}`} className="lift flex flex-wrap items-center gap-4 rounded-md border border-stone-200 bg-white p-5">
        <div className="min-w-0 flex-1">
          <p className="font-display text-lg font-bold text-stone-900">{j.title}{j.featured && <span data-testid={`job-featured-${j.id}`} className="ml-2 rounded-full bg-amber-100 px-2 py-0.5 align-middle text-[10px] font-mono uppercase text-amber-800">Featured</span>}</p>
          {admin && <p className="text-sm text-stone-600">{j.business?.name}</p>}
          <JobMeta j={j} />
        </div>
        <div className="text-right text-xs text-stone-500">
          <p>{j.view_count ?? 0} views · {j.applicant_count ?? 0} applicants · {j.suggestion_count ?? 0} suggested</p>
          <p className="font-mono">{fmtDate(j.created_at)}</p>
        </div>
        <StatusBadge status={j.status} testId={`job-status-${j.id}`} />
      </Link>
    ))}
  </div>
);

export default function Jobs() {
  const { user } = useAuth();
  const { data, setData } = useFetch("/jobs");
  const [open, setOpen] = useState(false);
  return (
    <div>
      <PageHeader eyebrow="Recruit" title="Job ads" desc="Post roles for candidates to apply. Our team approves each ad and may suggest candidates we think fit.">
        <Button data-testid="post-job-button" disabled={!isMember(user)} onClick={() => setOpen(true)}><Plus className="mr-1.5 h-4 w-4" />Post a job</Button>
      </PageHeader>
      {data?.length === 0 && <EmptyState testId="jobs-empty" icon={Megaphone} title="No job ads yet" desc="Post your first role and start receiving applicants." />}
      <JobList jobs={data || []} base="/app/jobs" />
      <JobFormDialog open={open} onOpenChange={setOpen} onCreated={(j) => setData((p) => [j, ...(p || [])])} />
    </div>
  );
}
